import { render, staticRenderFns } from "./subirArchivos.vue?vue&type=template&id=41b40c4c&"
import script from "./subirArchivos.vue?vue&type=script&lang=js&"
export * from "./subirArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports